import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>Политика конфиденциальности</h2>
            <div>
                <p>Политика конфиденциальности приложения Dreamehome</p>
                <p>Введение</p>
                <p>Dreamehome — это платформа (или сервис) контроля и управления интеллектуальным оборудованием, предоставляемая
                    «Dreame Innovation Technology (Suzhou) Co., Ltd.» и ее аффилированными лицами (далее именуемыми «мы» или
                    «Dreame»).
                    Мы осознаем важность Ваших персональных данных и прикладываем все силы для их защиты. Мы предпримем все
                    необходимые
                    меры в рамках общепризнанных отраслевых стандартов безопасности для защиты Ваших персональных данных.Dreamehome.
                </p>
                <p>Перед использованием наших продуктов (или услуг), внимательно прочтите настоящую Политику конфиденциальности
                    приложения Dreamehome.</p>
                <p>Если Вы являетесь несовершеннолетним, Вам необходимо получить разрешение Вашего родителя или законного опекуна на
                    использование данного приложения после того, как они прочтут данные условия вместе с вами.</p>
                <p>Мы полностью учли Ваши потребности при разработке настоящей Политики конфиденциальности. Важно, чтобы Вы получили
                    полное представление о нашей практике сбора и использования персональных данных, а также усилиях для того, чтобы
                    Вы
                    могли управлять своими персональными данными, предоставленными нам. В настоящей Политике конфиденциальности
                    описан
                    порядок сбора, использования, раскрытия, обработки и хранения данных, которые Вы предоставляете нам при
                    использовании нашего приложения. Мы будем строго соблюдать положения настоящей Политики конфиденциальности при
                    использовании Ваших данных.</p>
                <p>Из настоящей Политики конфиденциальности Вы сможете узнать следующее:</p>
                <p>1. Данные, которые мы собираем, и порядок их использования</p>
                <p>2. Порядок использования файлов cookie и аналогичных технологий</p>
                <p>3. Порядок доверения прав обработки, передачи, отправки и раскрытия Ваших персональных данных</p>
                <p>4. Порядок хранения и защиты Ваших персональных данных</p>
                <p>5. Ваши права</p>
                <p>6. Порядок трансграничной передачи данных</p>
                <p>7. Наши контактные данные</p>
                <p>8. Порядок обновления политики конфиденциальности</p>
                <p>Приложение 1: Сведения сторонних SDK</p>
                <p>Мы стремимся обеспечить Вам лучший пользовательский опыт. В разных странах и регионах у нас есть специалисты по
                    защите данных (DPO), которые занимаются конфиденциальностью Ваших данных. Если у Вас возникнут какие-либо
                    вопросы по
                    поводу настоящей Политики конфиденциальности, Вы можете обратиться к соответствующему специалисту DPO согласно
                    контактным данным, указанным в разделе VII. Наш специалист DPO ответит на Ваш запрос в течение периода времени,
                    определенного требованиями соответствующих национальных политик и законов. Если Вас не удовлетворит наш ответ,
                    особенно если Вы посчитаете, что наши действия при обработке персональных данных нанесли ущерб Вашим законным
                    правам
                    и интересам, Вы можете подать иск в Народный суд соответствующей юрисдикции, обратиться с жалобой в
                    государственные
                    контролирующие органы или решить свои проблемы другими способами.</p>
                <ol>
                    <li>Данные, которые мы собираем, и порядок их использования</li>
                </ol>
                <p>Персональными называют любые данные, записанные электронным или иным способом, которые могут быть использованы
                    отдельно или вместе с другими данными для идентификации конкретного физического лица.</p>
                <p>Конфиденциальные персональные данные — это данные, которые после утечки, незаконного предоставления или похищения
                    могут поставить под угрозу личную и имущественную безопасность или привести к ущербу личной репутации,
                    психическому
                    и физическому здоровью, дискриминации и другим последствиям. К конфиденциальным персональным данным помимо
                    прочего
                    относятся номер удостоверения личности, личные биометрические данные, сведения банковского счета, имущества,
                    записи
                    о местонахождении, сведения сделок, персональные данные несовершеннолетних лиц в возрасте до 14 лет
                    (включительно) и
                    т.д.</p>
                <p>Сбор Ваших персональных данных осуществляется с целью предоставления Вам продуктов и/или сервисов. Мы
                    гарантируем,
                    что будем использовать их в соответствии с применимыми законами, нормативными актами и другими нормативными
                    документами. Вы имеете право согласиться или отказаться от предоставления своих данных. Однако в большинстве
                    ситуаций в случае отказа мы не сможем предоставлять Вам соответствующие сервисы и отвечать на Ваши запросы.</p>
                <p>(I) Приложение Dreamehome собирает и обрабатывает Ваши персональные данные для предоставления основных сервисов
                </p>
                <p>(1) Dreamehome Подключение устройства и управление им</p>
                <p>Чтобы Вы могли безопасно подключаться и управлять своими умными устройствами при предоставлении наших сервисов,
                    мы
                    можем собирать Ваши данные о Wi-Fi, местоположении, аккаунте входа в систему, соответствующие данные о мобильном
                    телефоне, умном устройстве и данные о привязанных аккаунте Dreame и умном устройстве. Такие данные будут
                    использоваться для подключения функций, таких как Быстрое соединение (Quick Connect), Подключение (Connection ),
                    Поиск устройств поблизости (Find Nearby Devices) и Управление устройствами (Device Management). В частности, к
                    собираемым данным относятся:</p>
                <p>Данные входа в аккаунт: имя пользователя и пароль Вашего аккаунта Dreame, ник, фотография профиля, адрес
                    электронной почты и номер телефона. Среди них имя пользователя, пароль, номер телефона и адрес электронной почты
                    являются конфиденциальными персональными данными. Эти данные собираются для проверки Вашей личности и получения
                    разрешения на доступ к серверу с помощью Вашего аккаунта в приложении Dreamehome. Введенные имя пользователя и
                    пароль будут зашифрованы и переданы на сервер Dreame для аутентификации входа.</p>
                <p>Данные о мобильном телефоне: идентификаторы устройства (IMEI/OAID, Mac-адрес и Android ID), модель телефона,
                    версия
                    системы, страна или регион, размер и разрешение экрана, процессор и соответствующие данные устройства
                    отображения.
                    Эти данные собираются с тем, чтобы Вы могли подключить приложение Dreamehome к своим умным устройствам.</p>
                <p>Данные умного устройства: имя устройства, модель, версия, производитель, идентификатор, MAC-адрес, IP-адрес,
                    рабочий статус, пользовательские атрибуты, параметры настройки бизнес-событий, записи управления устройством и
                    его
                    использования. Эти данные собираются для привязки Вашего умного устройства, чтобы Вы могли им управлять,
                    настраивать
                    свойства и параметры устройства, а также просматривать статус и историю работы Вашего устройства.</p>
                <p>(2) Dreamehome Обновление приложения ххх и умного устройства</p>
                <p>Чтобы Вы могли непрерывно пользоваться нашими новейшими сервисами, мы можем использовать данные версии Вашего
                    приложения Dreamehome и модель телефона для предоставления обновленных сервисов. Кроме того, с этой целью мы
                    также
                    можем собирать данные списка подключенных устройств и данные версий, чтобы Вы могли использовать последние
                    версии
                    наших сервисов (включая версию прошивки). Приложение Dreamehome предоставляет только обновленные сервисы для
                    Ваших
                    умных устройств. Производитель умного устройства предоставляет соответствующую прошивку и несет ответственность
                    за
                    ее качество и результат обновления.</p>
                <p>Если Вы решите не предоставлять вышеуказанные данные, Вы не сможете обновить приложение Dreamehome и свое умное
                    устройство.</p>
                <p> (3) Онлайн-сервис обратной связи о проблемах</p>
                <p>Чтобы помочь Вам эффективно решать возможные проблемы с приложением Dreamehome и Вашим умным устройством, мы
                    предлагаем онлайн-сервис обратной связи о проблемах, которому требуются Ваши персональные данные, в том числе:
                    журналы работы приложения Dreamehome и Вашего умного устройства, Ваши контактные данные, описания проблем, а
                    также
                    соответствующие фотографии и видео. В журналах приложений и устройств указываются данные состояния устройства,
                    данные обнаружения датчиков, записи о работе устройства, идентификаторы устройств и т.д. Эти данные собираются
                    для
                    анализа и выявления причин возникновения проблемы. Ваши контактные данные собираются таким образом, чтобы мы
                    могли
                    отслеживать и контролировать процесс обработки заявки и более эффективно помогать решению Вашей проблемы.</p>
                <p>Ваши персональные данные будет использоваться только для анализа и решения проблем и не будут раскрываться или
                    использоваться в коммерческих интересах. Если Вы не предоставите такие данные, мы не сможем эффективно выявлять
                    и
                    решать Ваши проблемы.</p>
                <p>(II) ПриложениеDreamehome собирает и обрабатывает Ваши персональные данные для предоставления дополнительных
                    функций </p>
                <p>Помимо предоставления основных сервисов приложенияDreamehome, нам также может потребоваться собирать и
                    использовать
                    Ваши персональные данные для некоторых дополнительных функций. Если Вы не предоставите эти данные, Вы все равно
                    сможете воспользоваться основными сервисами приложенияDreamehome, но, возможно, не сможете использовать
                    дополнительные функции, которые смогут упростить Вашу работу. В дополнение к основным сервисам
                    приложениемDreamehome
                    также предлагается следующее:</p>
                <p>Программа улучшения пользовательского опыта:</p>
                <p>Чтобы улучшить Ваш пользовательский опыт, нам требуется собирать журналы приложенияDreamehome, включая журналы
                    зашифрованных ключевых процессов, журналы событий, журналы сбоев, данные бизнес-событий, использования каждого
                    интерфейса и т.д. Ваши конфиденциальные персональные данные не будут записываться в журналы.</p>
                <p>Ваши персональные данные будут использоваться следующими способами: </p>
                <p>вышеуказанные данные будут автоматически собраны и выгружены на сервер, данные журнала будут проанализированы для
                    диагностики рабочего статуса и анализа использования приложения.</p>
                <p>Если Вы не предоставите эти данные, приложениеDreamehome не сможет своевременно улучшать Ваш пользовательский
                    опыт,
                    но Вы все равно сможете использовать его основные сервисы.</p>
                <p>(III) Мы можем собирать Ваши персональные данные через сторонние источники</p>
                <p>В некоторых случаях мы можем законно получить Ваши персональные данные через сторонний источник. </p>
                <p>После получения Вашего согласия мы будем сотрудничать со сторонними поставщиками услуг для управления Вашими
                    умными
                    устройствами, в процессе которого будем собирать Ваши персональные данные от сторонних поставщиков услуг. Если
                    Вы
                    управляете своим умными устройством с помощью стороннего аккаунта, мы получим Ваши персональные данные после
                    привязки приложения к данному аккаунту. Будет осуществляться сбор следующих данных:</p>
                <p>Данные Вашего стороннего аккаунта, включая ник и фотографию профиля, которая отображается в приложении
                    Dreamehome;
                </p>
                <p>Данные устройства и сети, включая идентификатор устройства, MAC-адрес и серийный номер устройства для
                    распознавания
                    текущего устройства и контроля безопасности.</p>
                <p>Если обработка Ваших персональных данных для предпринимательской деятельности выйдет за рамки Вашего
                    первоначального разрешения и согласия при предоставлении этих данных стороннему поставщику услуг, мы запросим
                    Ваше
                    согласие до обработки данных. Кроме того, мы будем строго соблюдать соответствующие законы и нормативные акты, а
                    также требовать от соответствующих сторонних поставщиков услуг гарантировать законность предоставляемых ими
                    данных.
                </p>
                <p>(IV) Информация, не содержащая персональных данных</p>
                <p>Мы также можем собирать другие данные, которые не могут быть использованы для идентификации конкретного человека
                    (т.е. данные, которые не являются персональными), например статистические данные, генерируемые при использовании
                    определенного сервиса, поведение пользователя (включая клики, переходы на страницы и время просмотра). Эти
                    данные
                    собираются с целью улучшения наших сервисов. Тип и количество собираемых данных зависят от того, как Вы
                    используете
                    наши продукты и/или сервисы. Мы будем собирать эти данные, чтобы предоставлять более понятную для пользователей
                    информацию и изучать предпочтения клиентов в отношении нашего веб-сайта, продуктов и сервисов, а также с целью
                    оптимизации наших сервисов. В настоящей Политике конфиденциальности такие собираемые данные рассматриваются как
                    информация, не содержащая персональных данных. Однако если неперсональные данные объединяются с используемыми
                    персональными данными, такие неперсональные данные рассматриваются как персональные.</p>
                <p>II. Порядок использования файлов cookie и аналогичных технологий</p>
                <p>Для обеспечения нормального функционирования приложения Dreamehome мы будем хранить на Вашем устройстве небольшой
                    файл данных с названием Файлы cookie. К файлам cookie обычно относятся идентификаторы, имена сайтов и некоторые
                    цифры и символы. С помощью файлов cookie приложение Dreamehome может хранить данные Вашего аккаунта для входа на
                    веб-сайт, предпочтения и другие данные.</p>
                <p>Мы не будем использовать файлы cookie для каких-либо иных целей, кроме тех, которые указаны в настоящей Политике
                    конфиденциальности. Вы можете управлять или удалять файлы cookie на свое усмотрение. Однако в таком случае в
                    некоторых ситуациях Вы не сможете получать безопасный доступ к приложению Dreamehome, и Вам может потребоваться
                    изменять пользовательские настройки при каждом доступе к приложению Dreamehome.</p>
                <p>III. Порядок доверения права обработки, передачи, отправки и раскрытия Ваших персональных данных</p>
                <p>(I) Обработка по доверению</p>
                <p>В некоторых обстоятельствах Dreame может поручить другим компаниям обработку Ваших персональных данных, например
                    для связи с Вами, отправки электронных писем или предоставления технической поддержки от нашего имени. Эти
                    компании
                    могут использовать Ваши персональные данные только для предоставления вам сервисов от нашего имени.</p>
                <p>Мы подпишем строгое соглашение о конфиденциальности или соглашение об обработке персональных данных с доверенной
                    стороной и потребуем, чтобы персональные данные обрабатывались в соответствии с настоящей Политикой
                    конфиденциальности и были приняты соответствующие меры по обеспечению конфиденциальности и безопасности.</p>
                <p>(II) Передача</p>
                <p>В обычных условиях Dreame не будет передавать Ваши персональные данные другим компаниям, организациям или частным
                    лицам, за исключением следующих случаев:</p>
                <ol>
                    <li>С Вашего согласия мы передадим данные в рамках Вашего разрешения третьей стороне, включая данные и настройки
                        Ваших продуктов умного дома Ваших родственников и друзей, которые пользуются этими продуктами совместно с
                        Вами,
                        чтобы они могли получить быстрый доступ к программному обеспечению и сервисам на своих терминальных
                        устройствах.
                    </li>
                </ol>
                <p>2. Некоторые сервисы приложения Dreamehome, такие как хостинг веб-сайта, анализ данных, обработка платежей и
                    кредитных карт, инфраструктурная поддержка, IT-сервисы, сервисы поддержки клиентов, отправки электронных писем и
                    другие подобные сервисы, предоставляются сторонними поставщиками услуг. По этой причине мы должны предоставить
                    некоторые Ваши персональные данные сторонним поставщикам услуг, чтобы они могли предоставлять нам эти услуги.
                </p>
                <p>3. Мы можем раскрывать Ваши персональные данные клиентам и другим деловым партнерам, которые прямо или косвенно
                    предоставляют Вам умные устройства и/или сети и системы, чтобы Вы могли получить доступ и использовать наш
                    веб-сайт
                    и сервисы.</p>
                <p>4. Если Dreame будет участвовать в реорганизации, слиянии, продаже активов, совместном управлении, отчуждении,
                    передаче или других действиях, когда наш бизнес, активы или акции должны будут полностью или частично быть
                    отчуждены
                    (включая помимо прочего любой вид банкротства или аналогичные процедуры, связанные с вышеуказанными
                    обстоятельствами), мы можем раскрыть Ваши персональные данные аффилированным компаниям или другим третьим лицам.
                    Перед этим Вы получите уведомление по электронной почте и/или на нашем веб-сайте о смене владельца,
                    невозможности
                    нового использования персональных данных и необходимости авторизации Ваших персональных данных.</p>
                <p>5. Если мы будем убеждены в том, что доступ, использование, хранение или раскрытие данных в разумных пределах
                    необходимо для: (а) соблюдения применимых законов и нормативных актов; (б) соблюдения юридических процедур; (в)
                    реагирования на требования государственных учреждений и государственных органов, в том числе за пределами
                    страны/региона Вашего проживания; (г) исполнения наших условий и положений; (д) защиты наших операций, бизнеса и
                    системы; (е) защиты наших прав, частной жизни, безопасности или собственности и/или наших пользователей, включая
                    Вас; и (ж) поиска доступных средств правовой защиты либо ограничения компенсации ущерба, мы, возможно, должны
                    будем
                    раскрыть эти данные.</p>
                <p>6. Мы можем раскрывать Ваши персональные данные нашим филиалам или аффилированным компаниям для осуществления их
                    регулярной предпринимательской деятельности.</p>
                <p>7. Мы будем передавать необходимые данные третьим лицами через интерфейсы прикладного программирования (API) и
                    наборы разработки программных средств (SDK). Сторонние SDK отличаются в зависимости от версий, но как правило
                    делятся на типы для входа в сторонние аккаунта, типы общего доступа и оплаты сторонних аккаунтов, типы
                    push-уведомлений от производителей, типы статистики и т.д. Мы проведем строгую проверку безопасности третьих лиц
                    и
                    согласуем меры по защите данных. В Приложении 1 мы перечислили детали разрешенных сторонних SDK, с которым
                    рекомендуем Вам ознакомиться. Наша Политика конфиденциальности не распространяется на продукты или сервисы,
                    предоставляемые третьими лицами. Ваши персональные данные могут быть собраны при использовании Вами этих
                    продуктов
                    или сервисов. Поэтому мы настоятельно рекомендуем Вам найти время, чтобы ознакомиться с политикой
                    конфиденциальности
                    третьих лиц наряду с нашей. Мы не несем ответственности и не контролируем то, как третьи лица используют Ваши
                    собранные данные. Наша Политика конфиденциальности не распространяется на другие веб-сайты, связанные с нашими
                    сервисами. Вы несете ответственность за сохранность Ваших персональных данных при взаимодействии с веб-сайтами
                    по
                    ссылкам. Прежде чем Вы впервые перейдете на стороннюю страницу, сторонний поставщик услуг отобразит Вам
                    соответствующие соглашения и заявления о конфиденциальности. Ркекомендуем внимательно с ними ознакомиться.</p>
                <p>(III) Отправка</p>
                <p>Dreame не будет передавать Ваши персональные данные каким-либо компаниям, организациям или частным лицам, за
                    исключением следующих случаев:</p>
                <ol>
                    <li>С Вашего согласия: мы передадим Ваши персональные данные другим лицам только после получения Вашего
                        согласия;
                    </li>
                </ol>
                <p>2. Если Dreame будет участвовать в слиянии, приобретении или ликвидации при банкротстве, для которых необходима
                    передача персональных данных, мы потребуем, чтобы новая компания или организация, владеющая Вашими персональными
                    данными, продолжала соблюдать настоящую Политику конфиденциальности. В противном случае мы потребуем, чтобы
                    компания
                    или организация снова получила Ваше согласие.</p>
                <p>(IV) Раскрытие</p>
                <p>Мы не будем разглашать Ваши персональные данные публично, за исключением следующих случаев:</p>
                <ol>
                    <li>С Вашего согласия;</li>
                    <li>При наличии юридических оснований: мы можем публично раскрывать Ваши персональные данные в соответствии с
                        законом или на основе юридических процедур, судебных разбирательств или обязательных требований
                        государственных
                        органов.</li>
                </ol>
                <p>IV. Порядок хранения и защиты Ваших персональных данных</p>
                <p>Мы храним персональные данные в течение периода, необходимого для сбора данных, указанных в настоящей Политике
                    конфиденциальности, либо в соответствии с применимыми законными требованиями. Мы прекратим хранение Ваших
                    персональных данных и удалим или анонимизируем их после того, как завершим их сбор, либо после того, как
                    подтвердим
                    Ваше заявление об удалении или отмене, либо после того, как прекратим работу соответствующих продуктов или
                    сервисов.
                    Если это потребуется в общественных интересах, научных, исторических исследованиях или статистических целях, мы
                    будем продолжать хранить соответствующие данные на основе применимого законодательства, даже если дальнейшая
                    обработка данных не будет связана с первоначальной целью сбора.</p>
                <p>Для работы приложения Dreamehome хранение Ваших персональных данных продолжается следующим образом:</p>
                <p>Для данных, хранящихся локально в приложении Dreamehome: при удалении приложения или очистке его данных все
                    сохраненные данные будут удалены немедленно.</p>
                <p>Для умного устройства и хранения бизнес-данных на сервере: после удаления умного устройства, отказа от согласия с
                    политикой конфиденциальности приложения Dreamehome и прекращения использования сервисов приложения Dreamehome
                    все
                    сохраненные данные будут удалены немедленно.</p>
                <p>Для бизнес-журналов, статистических данных и исторических записей, хранящихся на сервере: периодическое удаление
                    при очистке данных сервера. Обычно такие данные хранятся не более 2 лет.</p>
                <p>Кроме того, если Dreame прекратит работу соответствующих продуктов или сервисов, мы сообщим Вам об этом через
                    push-уведомления, объявления и т.д. и удалим Ваши персональные данные либо анонимизируем их в течение разумного
                    периода времени.</p>
                <p>V. Ваши права</p>
                <p>(I) Доступ, изменение и удаление</p>
                <p>В соответствии с местными применимыми законами и нормативными актами, Вы имеете право запросить доступ, изменить
                    или удалить любые данные, которые мы собираем от Вас (далее по тексту — «запрос»). В этом случае напишите нам
                    или
                    свяжитесь с нами, посетив Dreamehome приложения Dreamehome. В соответствии с основными законами, запрос субъекта
                    персональных данных должен соответствовать определенным требованиям. </p>
                <p>В настоящей Политике конфиденциальности требования к субъектам персональных данных включают:</p>
                <p>Запрос должен быть сделан через наши специальные каналы запроса. Для обеспечения безопасности Ваших персональных
                    данных запрос должен быть составлен в письменной форме (если только местное законодательство четко не признает
                    устный запрос);</p>
                <p>Вы должны предоставить нам достаточно сведений, чтобы мы могли подтвердить Вашу личность и убедиться, что запрос
                    сделан самим пользователем или лицом, законно уполномоченным пользователем;</p>
                <p>Как только мы получим достаточно сведений для подтверждения, что можем обработать Ваш запрос, мы ответим Вам в
                    течение срока, установленного применимыми законами о защите данных. В частности, наши ответы включают:</p>
                <p>На основании Вашего запроса и применимых законов и нормативных актов мы можем бесплатно предоставить Вам копию
                    Ваших данных, которые были нами собраны и обработаны. За иные запросы данных может взиматься разумная плата в
                    зависимости от фактических производственных затрат в соответствии с применимым законодательством.</p>
                <p>Если Вы считаете, что какие-либо из хранимых нами данных являются недостоверными или неполными, Вы можете
                    запросить
                    их изменение или дополнение в зависимости от цели использования.</p>
                <p>В соответствии с применимыми законами и нормативными актами, Вы имеете право запросить удаление Ваших
                    персональных
                    данных. Вашему запросу будет дана оценка. Если он соответствует применимым законам и нормативным актам, мы
                    удалим
                    Ваши данные согласно соответствующим процедурам, включающим технологические меры. После того как соответствующие
                    данные будут удалены Вами или нами с Вашего согласия, мы не сможем немедленно удалить их из системы резервного
                    копирования на основании существующих законов и технологий безопасности. В таком случае мы обеспечим
                    безопасность
                    Ваших персональных данных и изолируем их от любой дальнейшей обработки до тех пор, пока они не будут удалены или
                    анонимизированы. Например, в соответствии с законом<em> «Об электронной торговле КНР»,</em> данные продуктов или
                    сервисов и сведения сделки должны храниться не менее трех лет со дня ее завершения.</p>
                <p>Мы имеем право отказать в обработке запроса в следующих случаях: запрос является необоснованным или оспариваемым;
                    запрос может нанести ущерб частной жизни других лиц; запрос крайне нереалистичен; запрос требует несоразмерной
                    технической работы; запрос может быть проигнорирован в соответствии с местными законами; данные были раскрыты;
                    данные были раскрыты на условиях конфиденциальности. Если мы посчитаем, что в некоторых случаях запрос на
                    удаление
                    или доступ к данным может помешать нам легально использовать эти данные в вышеуказанных целях борьбы с
                    мошенничеством и для обеспечения безопасности, мы также можем отклонить такой запрос.</p>
                <p>(II) Отзыв согласия</p>
                <p>Вы можете отправить запрос, чтобы отозвать Ваше согласие на сбор, использование и/или раскрытие персональных
                    данных, которые находятся в распоряжении компании Dreame и контролируются ею. Для этого в зависимости от
                    используемого сервиса Вы можете связаться с нами с помощью контактных данных, указанных в Пункте 7 настоящей
                    Политики конфиденциальности. После получения Вашего запроса мы обработаем его в разумные сроки. В зависимости от
                    типа запроса компания Dreame больше не будет выполнять сбор, использование и/или раскрытие Ваших персональных
                    данных.</p>
                <p>Обратите внимание, что в зависимости от объема, в пределах которого Вы разрешаете нам обработку Ваших данных, в
                    результате отзыва согласия Вы не сможете получить доступ к сервисам приложения Dreamehome или подключенным к
                    нему
                    умным устройствам. Однако Ваше решение отозвать или дать свое согласие не повлияет на предыдущую обработку
                    персональных данных на основании Вашего согласия.</p>
                <p>Вы также можете отказаться от участия в Программе улучшения пользовательского опыта, запросив отзыв согласия или
                    посетивDreamehome(III) Удаление аккаунта Dreamehome</p>
                <p>Вы можете удалить аккаунт Dreamehome, перейдя в раздел Я — Настройки аккаунта — Удалить аккаунт. Обратите
                    внимание,
                    что в случае удаления аккаунта Вы больше не сможете использовать платформу Dreamehome, а также все серии
                    интеллектуальных аппаратных продуктов и сервисов. В целях защиты законных прав и интересов Вас и третьих лиц мы
                    определим, следует ли одобрить Ваш запрос на удаление аккаунта на основании порядка использования Вами
                    интеллектуальных аппаратных продуктов и сервисов Dreamehome.</p>
                <p>VI. Порядок трансграничной передачи данных</p>
                <p>Dreame полагается на свои ресурсы и серверы по всему миру для предоставления Вам продуктов и/или сервисов. Таким
                    образом, с Вашего согласия Ваши персональные данные могут быть переданы в другие юрисдикции за пределами
                    страны/региона использования продуктов или сервисов, либо могут стать доступны этим юрисдикциям. Политика защиты
                    данных и соответствующие законы в стране/регионе, куда могут быть переданы Ваши данные, могут быть не такими
                    всеобъемлющими, как в Вашей текущей стране/регионе. В таких обстоятельствах мы примем надлежащие законные меры в
                    соответствии с применимыми законами соответствующей юрисдикции, чтобы обеспечить дальнейшую защиту Ваших
                    персональных данных.</p>
                <p>Примечание.</p>
                <p>Если Вы являетесь резидентом Европейской экономической зоны (ЕЭЗ) и Ваши персональные данные передаются за
                    пределы
                    ЕЭЗ, мы будем: обрабатывать Ваши персональные данные в пределах зоны, где Европейская комиссия может обеспечить
                    достаточный уровень защиты; либо предпринимать соответствующие защитные меры для защиты Ваших персональных
                    данных,
                    включая передачу Ваших данных в соответствии с применимыми правилами передачи данных, такими как Стандартные
                    договорные условия Европейской комиссии (SCC).</p>
                <p>VII. Наши контактные данные</p>
                <p>Если у Вас возникнут какие-либо комментарии или вопросы по поводу настоящей Политики конфиденциальности, а также
                    по
                    поводу сбора, использования или раскрытия Ваших персональных данных, свяжитесь с нами по контактным данным ниже
                    либо
                    посетите Dreamehome приложения Dreamehome. Озаглавьте сообщение — «Политика конфиденциальности». Наша команда
                    специалистов отреагирует на Ваши вопросы и проблемы. Если Ваш вопрос затронет важные вопросы, мы можем попросить
                    Вас
                    предоставить дополнительную информацию. Если Вы окажетесь недовольны нашим ответом, Вы можете подать жалобу в
                    соответствующий надзорный орган Вашей юрисдикции. Если Вы обратитесь к нам по поводу каналов подачи жалобы, мы
                    предоставим Вам варианты в зависимости от реальной ситуации.</p>
                <p><strong>Эл. почта</strong></p>
                <ul>
                    <li>Китай: <a className='page'
                        href="mailto:privacy@dreame.tech">privacy@dreame.tech</a> </li>
                    <li>Специалисты по защите данных в Сингапуре: <a className='page'
                        href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a></li>
                    <li>Представитель в ЕС: <a className='page'
                        href="mailto:representative.dreame@herrero.es">representative.dreame@herrero.es</a></li>
                </ul>
                <p><strong>Контактный телефон</strong>: 400-875-9511</p>
                <p><strong>Веб-сайт</strong>: <a className='page'
                    href="https://www.dreame-technology.com">https://www.dreame-technology.com</a> </p>
                <p>VIII. Порядок обновления </p>
                <p>Dreame оставляет за собой право своевременно обновлять настоящую Политику конфиденциальности. В случае каких-либо
                    изменений мы сообщим Вам об этом во всплывающем сообщении или другими известными способами. Мы будем собирать,
                    использовать и хранить Ваши персональные данные в соответствии с обновленной политикой только с Вашего согласия.
                </p>
                <p>Настоящая политика вступает в силу с момента ее обновления.</p>
                <p>Дата последнего обновления: 28/08/2021</p>
                <p>Приложение 1: Сторонние данные SDK</p>
                <p>* Приложение Dreamehome использует набор сторонних SDK, чтобы предоставлять Вам более профессиональные и
                    безопасные
                    основные и дополнительные функции и сервисы. Подробнее о сторонних SDK, используемых в приложении Dreamehome,
                    см.
                    ниже:</p>
                <div className='tableStyle'>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <p>SDK</p>
                                </td>
                                <td>
                                    <p>Функции</p>
                                </td>
                                <td>
                                    <p>Собранные данные</p>
                                </td>
                                <td>
                                    <p>Сторонняя политика конфиденциальности</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>SDK анализа статистики Umeng</p>
                                </td>
                                <td>
                                    <p>Анализ статистики</p>
                                </td>
                                <td>
                                    <p>Идентификатор устройства (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, IMSI ДАННЫЕ SIM-КАРТЫ),
                                        местоположение</p>
                                </td>
                                <td>
                                    <p><a className='page'
                                        href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>SDK push-уведомлений Umeng</p>
                                </td>
                                <td>
                                    <p>Push-уведомления</p>
                                </td>
                                <td>
                                    <p>Идентификатор устройства (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, IMSI ИНФОРМАЦИЯ О SIM-КАРТЕ),
                                        местоположение</p>
                                </td>
                                <td>
                                    <p><a className='page'
                                        href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>SDK USB-передачи Umeng</p>
                                </td>
                                <td>
                                    <p>Передача третьим лицам</p>
                                </td>
                                <td>
                                    <p>Идентификатор устройства (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, IMSI ИНФОРМАЦИЯ О SIM-КАРТЕ),
                                        местоположение</p>
                                </td>
                                <td>
                                    <p><a className='page'
                                        href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>SDK Agora</p>
                                </td>
                                <td>
                                    <p>Подключение голосового общения и видеостриминга</p>
                                </td>
                                <td>
                                    <p>Данные устройства, статус сети, камера, микрофон, хранение прочтения и записи данных</p>
                                </td>
                                <td>
                                    <p><a className='page'
                                        href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>SDK отправки данных Huawei</p>
                                </td>
                                <td>
                                    <p>Отправка данных</p>
                                </td>
                                <td>
                                    <p>Идентификатор устройства </p>
                                </td>
                                <td>
                                    <p><a className='page'
                                        href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>SDK отправки данных Xiaomi</p>
                                </td>
                                <td>
                                    <p>Отправка данных</p>
                                </td>
                                <td>
                                    <p>Идентификатор устройства, модель устройства, тип сети, память устройства, данные процесса работы
                                        устройства,
                                        версия заявки, версия SDK</p>
                                </td>
                                <td>
                                    <p><a className='page'
                                        href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>SDK отправки данных OPPO</p>
                                </td>
                                <td>
                                    <p>Отправка данных</p>
                                </td>
                                <td>
                                    <p>Идентификатор устройства </p>
                                </td>
                                <td>
                                    <p><a className='page'
                                        href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>SDK отправки данных VIVO</p>
                                </td>
                                <td>
                                    <p>Отправка данных</p>
                                </td>
                                <td>
                                    <p>Идентификатор устройства </p>
                                </td>
                                <td>
                                    <p><a className='page'
                                        href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>SDK WeChat</p>
                                </td>
                                <td>
                                    <p>Вход в WeChat, передача через WeChat </p>
                                </td>
                                <td>
                                    <p>Идентификатор устройства, данные сети</p>
                                </td>
                                <td>
                                    <p><a className='page'
                                        href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>SDK QQ</p>
                                </td>
                                <td>
                                    <p>Передача через QQ</p>
                                </td>
                                <td>
                                    <p>Идентификатор устройства, данные сети</p>
                                </td>
                                <td>
                                    <p><a className='page'
                                        href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>SDK Weibo</p>
                                </td>
                                <td>
                                    <p>Вход в Weibo, передача через Weibo</p>
                                </td>
                                <td>
                                    <p>Идентификатор устройства, данные сети</p>
                                </td>
                                <td>
                                    <p><a className='page'
                                        href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>SDK аккаунта Apple</p>
                                </td>
                                <td>
                                    <p>Вход в аккаунт Apple</p>
                                </td>
                                <td>
                                    <p>Аккаунт Apple</p>
                                </td>
                                <td>
                                    <p><a className='page'
                                        href="https://www.apple.com/legal/privacy/szh/">https://www.apple.com/legal/privacy/szh/</a></p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default PricacyPolicy